<div class="all-title-box"><div class="container text-center"><h1>Create Account</h1></div></div>
<div class="section wb auth-page">
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="submit()" class="auth-card">
      <h3>Register</h3>
      <input class="form-control" type="text" formControlName="full_name" placeholder="Full name">
      <input class="form-control" type="email" formControlName="email" placeholder="Email">
      <input class="form-control" type="text" formControlName="phone" placeholder="Phone (optional)">
      <input class="form-control" type="password" formControlName="password" placeholder="Password">
      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
      <button class="btn btn-light btn-radius btn-brd grd1 btn-block" type="submit" [disabled]="isSubmitting">{{ isSubmitting ? 'Creating account...' : 'Create account' }}</button>
    </form>
  </div>
</div>
